import {v3} from "oc-threejs/short3";
import RaumO3 from "../object3d/Raum";

export default class Raum {
    // DO NOT CHANGE
    className = "Raum";

    // persistent (UserLayer) ------------------------------------------

    // transient (CompiledLayer) ---------------------------------------

    parent: Object;
    object3d: ?THREE.Object3D;
    position = new THREE.Vector3();
    quaternion = new THREE.Quaternion();
    parent3d: ?THREE.Object3D;
    size = v3();
    box = new THREE.Box3();
    matrix = new THREE.Matrix4();
    bodenMaterial = undefined;
    wandMaterial = undefined;

    constructor(parent) {
        this.parent = parent;
    }

    get arrangement() {
        return this.parent;
    }

    compile() {
        this.compileMaterials();
        APP.model.lazyCreateObject3d(this, () => {
            const o3 = new RaumO3(this);
            this.arrangement.object3d.add(o3);
            //Code Smell: der Raum als erstes Kind im Arrangement verhindert renderprobleme mit rulern,
            this.arrangement.object3d.children.sort((a,b)=>a==o3?-1:(b==o3?1:0));
            this.arrangement.object3d.raum = o3;
            return o3;
        });


        // TODO: Auf Settings legen!
        const roomSettingsName = APP.arrangement.schraenke[0].options.getValue("raum_name");
        const raumSettings = APP.metadata.Raum.find(raum => raum.name === roomSettingsName);
        const hoehe = raumSettings.Raumhoehe;
        const tiefe = raumSettings.Raumtiefe;
        const breite = raumSettings.Raumbreite;
        this.size.set(breite,hoehe,tiefe);
        this.position.set(0,hoehe/2, tiefe/2);
        this.box.setFromCenterAndSize(v3(0,0.5,0.5).multiply(this.size),this.size);
    }

    compileMaterials() {
        if(APP.arrangement.schraenke.length > 0 && (!this.bodenMaterialName || !this.wandMaterialName)) {
            const roomSettingsName = APP.arrangement.schraenke[0].options.getValue("raum_name");
            const raumSettings = APP.metadata.Raum.find(raum => raum.name === roomSettingsName);
            if(raumSettings) {
                this.bodenMaterialName = raumSettings.BodenMaterial;
                this.wandMaterialName = raumSettings.WandMaterial;
            }

        }
    }

    iterate(iterator) {
        iterator(this);
    }

}
